// BSD 客服与政策页：手机宽度下目录默认收起，点目录项后自动收起。
(() => {
  const init = () => {
    const mobile = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('.bsd-care__toc').forEach((toc) => {
      if (toc.dataset.ready) return;
      toc.dataset.ready = 'true';
      if (mobile.matches) toc.removeAttribute('open');
      toc.addEventListener('click', (event) => {
        if (mobile.matches && event.target.closest('a')) toc.removeAttribute('open');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
